if (!window.customCardProductSliderInitialized) {
  window.customCardProductSliderInitialized = true;

  function initVideoAutoplay() {
    if (!("IntersectionObserver" in window)) {
      // Fallback: just try playing all videos immediately
      document
        .querySelectorAll(".card__media-slide video")
        .forEach(function (v) {
          v.muted = true;
          v.play().catch(function () {});
        });
      return;
    }

    const videoObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.muted = true; // ensure muted (required for autoplay on mobile)
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.3 },
    ); // play when 30% of the video is visible

    document
      .querySelectorAll(".card__media-slide video")
      .forEach(function (video) {
        videoObserver.observe(video);
      });
  }

  // Run on DOMContentLoaded and also observe dynamically added cards
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initVideoAutoplay);
  } else {
    initVideoAutoplay();
  }

  // Re-observe videos added later (e.g. via lazy section loading)
  if ("MutationObserver" in window) {
    const mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            const videos = node.querySelectorAll
              ? node.querySelectorAll(".card__media-slide video")
              : [];
            if (videos.length) initVideoAutoplay();
            // Also check if the node itself is a video slide
            if (node.matches && node.matches(".card__media-slide video")) {
              initVideoAutoplay();
            }
          }
        });
      });
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  // ── Pause/play videos when slider is scrolled between slides ────────────
  document.addEventListener(
    "scroll",
    function (e) {
      const slider = e.target.closest(".card__media-slider");
      if (!slider) return;

      const index = Math.round(slider.scrollLeft / slider.clientWidth);
      const inner = slider.closest(".card__inner");
      if (!inner) return;

      // Update active dot indicator
      const dotsContainer = inner.querySelector(".card__media-dots");
      if (dotsContainer) {
        // const dots = dotsContainer.querySelectorAll('.card__media-dot');
        // dots.forEach(function (dot, idx) {
        //     dot.classList.toggle('active', idx === index);
        // });
        const thumbs = inner.querySelectorAll(".card__media-thumbnail");

        thumbs.forEach(function (thumb, idx) {
          thumb.classList.toggle("active", idx === index);
        });
      }

      // Play the video on the active slide, pause others
      const slides = slider.querySelectorAll(".card__media-slide");
      slides.forEach(function (slide, idx) {
        const video = slide.querySelector("video");
        if (!video) return;
        if (idx === index) {
          video.muted = true;
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    },
    true,
  );

  // Handle click events on navigation arrows and pagination dots
  document.addEventListener("click", function (e) {
    const thumb = e.target.closest(".card__media-thumbnail");

    if (thumb) {
      e.preventDefault();
      e.stopPropagation();

      const index = Number(thumb.dataset.index);
      const inner = thumb.closest(".card__inner");
      const slider = inner.querySelector(".card__media-slider");

      if (!slider) return;

      slider.scrollTo({
        left: slider.clientWidth * index,
        behavior: "smooth",
      });

      inner.querySelectorAll(".card__media-thumbnail").forEach((item, i) => {
        item.classList.toggle("active", i === index);
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initCollectionCardAddToCart();
});

function initCollectionCardAddToCart() {
  const sizeButtons = document.querySelectorAll(
    ".card__size-option[data-variant-id]",
  );

  sizeButtons.forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (button.disabled || button.classList.contains("loading")) {
        return;
      }

      const variantId = button.dataset.variantId;

      if (!variantId) {
        console.error("Variant ID not found.");
        return;
      }

      const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      if (!cart) {
        console.error("Cart drawer / cart notification not found.");
        return;
      }
      button.classList.add("loading");
      button.disabled = true;

      try {
        const config = fetchConfig("javascript");

        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", "1");

        formData.append(
          "sections",
          cart.getSectionsToRender().map((section) => section.id),
        );

        formData.append("sections_url", window.location.pathname);
        if (typeof cart.setActiveElement === "function") {
          cart.setActiveElement(button);
        }

        config.body = formData;
        const response = await fetch(
          window.routes?.cart_add_url ||
            `${window.Shopify.routes.root}cart/add.js`,
          config,
        );

        const data = await response.json();
        if (data.status) {
          throw new Error(
            data.description ||
              data.message ||
              "Unable to add product to cart.",
          );
        }

        console.log("Product added to cart:", data);

        if (typeof cart.renderContents === "function") {
          cart.renderContents(data);
        } else {
          console.error("cart.renderContents() is not available.");
        }
      } catch (error) {
        console.error("Collection add to cart error:", error);
      } finally {
        button.classList.remove("loading");
        button.disabled = false;
      }
    });
  });
}
